module.exports = __webpack_public_path__ + "assets/img/9d24dcd145b0224f17af788cc9f15fe5.svg";